import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import translations from '@modules/i18n';
import {sdoNs} from '@modules/constants-enumerate';
import './sdo';
import {i18nMixin} from '@aofl/i18n-mixin';

const setTranslations = (ctx) => {
  const t10s = {
    orgMessage: {
        'frogstreet': ctx._r(ctx.__('<tt-tGXdsn0u>', `Please contact the administrator managing your account or submit a ticket to the Frog Street Customer Success team at  %r1%.`), `<a href="http://support.frogstreet.com" target="_blank">http://support.frogstreet.com</a>`),
        'inkas': ctx._r(ctx.__('<tt-+iEgZcVh>', `Please contact the administrator managing your account or email %r1%.`), `<a href="mailto:abc@inkas.com.tr" target="_blank">abc@inkas.com.tr</a>`),
    }
  };

  return t10s;
};

/**
 * @summary SupportWidget
 * @extends i18nMixin(AoflElement)
 */
@customElement('support-widget')
class SupportWidget extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of SupportWidget.
   */
  constructor() {
    super();
    this.translations = translations;
    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static is = 'support-widget';

  @property({type: Boolean, mapState: `${sdoNs.SUPPORT_WIDGET}.showForm`, store: storeInstance})
  showForm = false;

  @property({type: String, mapState: `${sdoNs.SESSION}.locale`, store: storeInstance})
  locale = '';

  @property({type: Boolean, mapState: `${sdoNs.SUPPORT_WIDGET}.$loadZendeskWidget`, store: storeInstance})
  loadZendeskWidget = false;

  @property({type: Boolean, mapState: `${sdoNs.SUPPORT_WIDGET}.$loadAdaWidget`, store: storeInstance})
  loadAdaWidget = false;

  @property({type: Number, mapState: `${sdoNs.SESSION}.group_info.root_id`, store: storeInstance})
  orgRootId = 1;

  @property({type: Object})
  orgMessage = {};

  @property({type: Object})
  orgsByRootIds = {
    149484: 'frogstreet',
    164977: 'frogstreet',
    225767: 'inkas',
    240506: 'inkas',
  }

  showSupportForm() {
    this.storeInstance.commit({
      namespace: sdoNs.SUPPORT_WIDGET,
      mutationId: 'setShowForm',
      payload: true
    });
  }

  closeSupportForm() {
    this.storeInstance.commit({
      namespace: sdoNs.SUPPORT_WIDGET,
      mutationId: 'setShowForm',
      payload: false
    });
  }

  getOrgMessage() {
    const org = this.orgsByRootIds[this.orgRootId];
    return this.orgMessage[org] || '';
  }

  connectedCallback() {
    super.connectedCallback();
    var t10s = setTranslations(this);
    for (let index in t10s) {
      this[index] = t10s[index];
    }
    if (this.loadZendeskWidget) {
      // Add Zendesk script it if we need it and it will dynamically loads an iframe
      const script = document.createElement('script');
      if (!document.getElementById('ze-snippet')) {
        script.setAttribute('src', `https://static.zdassets.com/ekr/snippet.js?key=${process.env.ZENDESK_API_KEY}`);
        script.setAttribute('id', 'ze-snippet');
        script.setAttribute('defer', 'defer');
        const head = document.head;
        head.insertBefore(script, head.firstElementChild);
        script.addEventListener('load', () => {
          window.zE(() => window.zE.setLocale(this.locale));
        });
      }
    } else if (this.loadAdaWidget) {
      const script = document.createElement('script');
      if (!document.getElementById('ada-snippet')) {
        window.adaSettings = {
          handle: "aoflgenerative"
        };
        script.setAttribute('src', 'https://static.ada.support/embed2.js');
        script.setAttribute('id', 'ada-snippet');
        script.setAttribute('data-handle', 'aoflgenerative');
        const head = document.head;
        head.insertBefore(script, head.firstElementChild);
      }
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (!this.loadZendeskWidget && !this.loadAdaWidget) {
      document.querySelector('iframe[data-product=web_widget]')?.remove();
      document.querySelector('iframe[id=launcher]')?.remove();
    }
  }

  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export default SupportWidget;
